module.exports = __webpack_public_path__ + "img/walkn.84671001.jpg";